export default {
    'zh-TW': {
        test: '測試',
        title: '標題',
        message: '訊息',
        langCode: '語言',
        desc: '描述',
        createdAt: '建立時間',
        updatedAt: '最後更新',
        contentType: '內容類型',
        logout: '登出',
        add: '新增',
        edit: '修改',
        trash: '刪除',
        deleteSelected: '刪除勾選',
        selected: '選擇',
        agreeSelected: '通過 user',
        publish: '上架',
        unpublish: '下架',
        clear: '清除',
        submit: '送出',
        typeContent: '故事',
        typeDecoration: '飾品',
        typeApplication: '應用',
        filterBy: '以 {column} 過濾',
        defaultOption: '選 {column}',
        bundle: '包',
        goods: '商品',
        content: '故事',
        decoration: '飾品',
        isBundle: '故事集',
        descGoodsBundle: '商品組合',
        descBuildBundle: '建立故事集',
        decorationBundle: '飾品包',
        buyOnMarket: '可購買',
        store: '商城',
        theater: '劇院',
        isStoreOrTheater: '給商城或劇院',
        yes: '是',
        no: '否',
        wishSelf: '自選',
        wishStoryContent: '故事內容',
        wishStoryVolume: '故事專輯',
        wishStoryGoods: '故事商品',
        wishDecorationGoods: '飾品商品',
        wishDecorationBundle: '飾品包',
        sort: '排序',
        sortAsc: '正序',
        sortDesc: '倒序',
        category: '類別',
        channel: '頻道',
        tag: '標籤',
        appType: 'app 類型',
        preload: '預載',
        market: '市場',
        size: '下載檔案大小',
        time: '時間',
        episode: '集數',
        priority: '優先順序',
        status: '狀態',
        publishBeginDate: '上架日期',
        publishBeginTime: '上架時間',
        publishEndDate: '下架日期',
        publishEndTime: '下架時間',
        downloadUrl: '下載連結',
        bannerUrl: 'banner 連結',
        imageUrl: '圖片連結',
        previewImageUrl: '預覽圖片連結',
        previewDownloadUrl: '預覽下載連結',
        creator: '建立者',
        currency: '幣別',
        price: '金額',
        version: '版本',
        success: '成功',
        playCount: '播放次數',
        sellCount: '銷售次數',
        commentRank: '評分',
        commentCount: '評分次數',
        flag: 'flag',
        order: 'order',
        typeZHCN: '簡體中文',
        typeZHTW: '繁體中文',
        typeEN: '英文',
        descTheaterDetail: '劇院的細節',
        descStoreDetail: '商城的細節',
        descImageUrl: '內頁圖片',
        descPreviewImageUrl: '封面圖片',
        exampleTime: '(30:20 代表檔案時間為30分20秒)',
        exampleEpisode: '(代表是第x集，例如 2 代表第二集)',
        noPublishEnd: '不下架',
        required: '必填',
        minValue: '最少',
        minLength: '長度不足',
        all: '全部',
        unPublishMessage: '確定要下架 ?',
        deleteMessage: '確定要刪除 ?',
        syncMessage: '確定要同步 ?',
        publishMessage: '確定要上架 ?',
        errorMessage: '發生錯誤',
        confirmMessage: '確定',
        type: '類型',
        typeStar: '優質',
        typeSell: '必備',
        typeRecommend: '主打星',
        descMenuUserList: '使用者列表',
        descMenuMessageList: '訊息列表',
        descMenuAppList: 'APP 列表',
        descMenuFileList: '檔案列表',
        descMenuSdkFileList: 'SDK 列表',
        descMenuSampleFileList: 'Sample Code 列表',
        descMenuAdminGoodsList: '商品列表',
        descMenuDashboard: '儀表板',
        descMenuReport: '報表列表',
        descMenuRecommendList: '推薦列表',
        descMenuFeedbackList: '商城 feedback 列表',
        descMenuOrderList: '訂單列表',
        descMenuCategoryList: '類別列表',
        descMenuChannelList: '頻道列表',
        descMenuTagList: '標籤列表',
        descMenuMarketList: '市場列表',
        descMenuHotList: '商城首頁列表',
        descMenuMiboNewsList: 'Mibo News 列表',
        descMenuMiboPetVersionList: 'Mibo pet 版本列表',
        descMenuGoodsList: '商品列表',
        descSync: '同步',
        descPublish: '上架',
        descPetRefreshInterval: '每 30 秒更新此頁面',
        descMenuMotionFileList: 'Motion 列表',
        descMenuMotionCategoryList: 'Motion 類別列表',
        descMenuMotionTagList: 'Motion 標籤列表',
        descMenuResourceDescription: 'Introduction',
        descMenuRobotSdk: 'NUWA Robot SDK',
        containThisContent: '包含此故事',
        uploading: '上傳中',
        email: '郵箱',
        invalidEmailFormat: '郵箱格式不正確',
        duplicateEmail: '您輸入的郵箱已存在',
        password: '密碼',
        confirmPassword: '確認密碼',
        phone: '電話',
        companyName: '公司名稱',
        sameAsPassword: '兩次密碼輸入不一致',
        package: 'package',
        keyName: 'key 名稱',
        platform: '服務平臺',
        publishSecret: '發佈版安全碼 SHA1',
        testSecret: '測試版安全碼 SHA1',
        appId: 'app Id',
        appKey: 'app key',
        expire: '過期時間',
        wantMessage: '希望收到 mail ?',
        indexProduct: '產品介紹',
        indexNews: '最新消息',
        indexResource: '資源中心',
        indexSDK: 'SDK',
        indexForum: '技術討論區',
        indexDoc: 'Doc',
        indexMotion: 'Motion',
        indexSampleCode: 'Sample Code',
        indexRegister: '註冊',
        indexLogin: '登入',
        indexControlPanel: '控制台',
        registerTitle: '成為開發者',
        registerFillInfo: '填寫帳號訊息',
        registerComplete: '完善開發者訊息',
        registerFinish: '註冊完成',
        registerFinishMessage: '等待管理員審核中，請注意信箱',
        addApp: '增加 APP',
        editApp: '修改 App',
        motionName: '動作名稱',
        motionDescription: '動作描述',
        keyword: '關鍵字',
        descAddI18n: '增加語言',
        technicalSupportSdk: '簡單易用的SDK讓您能快速获 Nuwa 技術并调用至您的 Android studio 或 Unity IDE',
        technicalSupportMotion: '查看能直接應用到專案中的機器人動作套件',
        technicalSupportAction: '動作列表',
        // [首页]
        buy_now: '立刻購買',
        language: '語言',
        developer_banner_title_01: '實現你的豐富想像',
        developer_banner_text_01: '透過女媧機器人，讓你的應用走入人們的生活',
        developer_feature_step_title: '開發我的小丹應用',
        developer_feature_step_text: '透過以下步驟，推出你的服務',
        developer_feature_support_title: '技術支持',
        developer_banner_buy: '還沒擁有自己的女媧機器人嗎？',
        developer_documentation_download: '下載',
        developer_documentation_sdk: '女媧機器人SDK',
        developer_feature_step_store: '商城發布',
        developer_feature_step_description_store: '商品上架，廣泛的小丹用戶可以開始使用你的商品',
        developer_feature_step_product: '產品驗證',
        developer_feature_step_description_product: '提交專案後，Nuwa 將針對應用內容及程式進行審核，以確保符合規範',
        developer_feature_step_creat: '創建與開發',
        developer_feature_step_description_creat: '根據應用類型創建不同專案，分別為應用程式、故事及飾品',
        developer_feature_step_sign: '登錄開發者',
        developer_feature_step_description_sign: '註冊帳號，認證開發者以開通功能',
        developer_feature_tool_ai: '生動語音人工智能',
        developer_feature_tool_description_ai: '女媧機器人搭載小愛同學，能快速應用小愛同學強大的語音辨識、自然語言處理及豐富的語音能力',
        developer_feature_tool_motion: '自由的肢體表現',
        developer_feature_tool_description_motion: '內建MCU微型控制器，支持360°旋轉運動,可以實現多角度關節動作，擁有更多可能性',
        developer_feature_tool_devtool: '便利的開發工具',
        developer_feature_tool_description_devtool: '目前提供動作套件，方便應用。未來將陸續推出內容開發及程式開發的多樣工具',
        developer_banner_store_title: '女媧商城讓您接觸到更多擁有女媧機器人的家庭。',
        developer_banner_store_text: '您能開發應用程式、故事、飾品等商品。並且，您的創意將被遍佈全國的孩子們使用。',
        developer_distribute_plan_title: '女媧開發者計畫',
        developer_distribute_plan_text: '基于女媧擁有的豐富軟體技術，幫助開發者們快速發展應用程式及內容。',
        developer_distribute_plan03_title: '客製化開發合作夥伴',
        developer_distribute_plan03_text: '與女媧協作開發，獲取更多資源。我們將進階提供 Unity SDK、更新服務，讓您的機器人的環境及軟體等能整體客製化更新。透過我們的更新服務，您將省下大量時間、精力及費用，即能創造您獨一無二的機器人。',
        developer_distribute_plan02_title: '進階開發合作夥伴',
        developer_distribute_plan02_text: '除了能自由在商城推出您的 app 之外，您還能再開發階段使用女媧提供的模擬器。透過模擬器，即使機器人不在身邊，您可以擁有機器人環境，繼續創造、優化您的 app。',
        developer_distribute_plan01_title: '平台開發者計畫',
        developer_distribute_plan01_text: '通過適用於女媧機器人的商城向全國用戶推出您的 app。您還可以獲取 測試工具、開發文件以及 app 分析。利用 Nuwa Developer Console 上的 App 分析來衡量您的用戶參與情況和收入狀況，且此分析無需額外技術性的編程配合。',
        developer_distribute_plan_update: '更新',
        developer_distribute_plan_unity: '統一SDK',
        developer_distribute_plan_store: '商城上架',
        developer_distribute_plan_tool: '內容及開發工具',
        developer_distribute_plan_doc: '開發文件',
        developer_distribute_plan_sdk: '下載SDK',
        developer_banner_rule_title: '準則與資源',
        developer_banner_rule_text: '閱讀設計與開發的規範，了解如何提交與行銷您的應用。',
        developer_documataion_overview_00_title: '機器人開發文件',
        developer_documataion_overview_01_title: '簡介',
        developer_documataion_overview_02_title: '應用程式如何在機器人上運作？',
        developer_documataion_overview_01_text: '女媧開發者平台讓您能增加、延伸女媧機器人上的功能。用戶可以透過對話來學習、玩遊戲或達到其他目的。身為開發者的您，可以利用平台上提供的文件及工具串連您的第三方服務，為用戶創造令人開心的使用經驗。',
        developer_documataion_overview_02_text: '當你計畫開發了女媧機器人的應用程式，你將會設計一個聲音、視覺交互應用或是結合兩者的服務。透過聲音或視覺，用戶能更清楚快速了解您的內容。當用戶和您的應用程式對話時，過程將在雲端運行。',
        // [账号]
        select_category: '請選擇一個種類',
        countries: '中國',
        company_job_information: '您的機構或公司資訊',
        basic_information: '基本信息',
        submit_info: '提交',
        write_plan: '寫下你的計畫...',
        proceed: '下一步',
        individual_developer: '個人開發者',
        enterprise_developer: '企業開發者',
        enter_email: '請輸入郵箱',
        empty_mailbox: '郵箱或者密碼不能爲空',
        creat_nuwa_account: '建立女媧開發者帳號',
        developer_account_remember_me: '記住我',
        developer_account_forget_password: '忘記密碼',
        developer_account_join_developer: '加入女媧開發者？',
        developer_account_password_warning: '密碼需包含 8-16 個字，並包含英數字元',
        developer_account_privacy: '當您註冊此帳號時，即表示您已閱讀、瞭解並同意接受用戶協議與隱私條款。',
        developer_account_have_account: '已擁有帳號了？',
        developer_account_forget_password_mail: '輸入您的電子信箱來重設密碼',
        developer_account_forget_mail: '如果你忘記了你的電子郵件，你可以查一下。',
        developer_account_active_mail: '就快完成囉！請驗證您的帳戶驗證信件已經寄到下方的信箱內',
        developer_account_active_mail_click: '點擊信箱內的認證信件來開通您的帳戶！',
        developer_account_not_get_mail: '尚未收到認證信？',
        developer_account_account_setup_complete: '帳號驗證成功！',
        developer_account_setup_log: '你可以此信箱作為女媧開發者的登入帳號',
        developer_account_enter_incorrectly: '帳號或密碼輸入錯誤',
        developer_account_description: '選擇您的帳號類別',
        developer_account_description_warning: '創建帳號後不得更改帳號類別',
        developer_account_information_real_name: '真實姓名',
        developer_account_information_id: '開發者代號',
        developer_account_information_country: '國家/地區',
        developer_account_information_company_name: '公司名稱',
        developer_account_information_category: '產業類別',
        developer_account_information_company_scale: '公司規模',
        developer_account_information_job_title: '您的職位',
        developer_account_information_website: '公司網站',
        developer_account_information_develop_plan_title: '開發計劃',
        developer_account_information_develop_plan_text: '請與我們分享您想開發的應用。您的目標是什麼？ 您想提供什麼類型的服務？',
        // [header]
        developmentPlan: '開發計劃',
        file: '文件',
        discuss: '討論',
        blog: 'Blog',
        login: '登錄',
        loginOut: '登出',
        loginUser: '用户',
        introductionPlatform: '平台簡介',
        developmentProcess: '開發流程',
        rulesDocument: '規則文檔',
        getStarted: '開始',
        instructionsSdk: 'SDK 說明',
        actionListDescription: '動作清單說明',
        nuwaEnterpriseIdentification: 'Nuwa 企業識別',
        dannyEnterpriseIdentification: 'Danny 企業識別',
        console: '控制台',
        myConsole: '我的控制台',
        loginError: '您的ID或密碼輸入錯誤',
        serverAppears: '服務器或網絡連接錯誤',
        resources: '資源',
        support: '支援',
        aboutNuwa: '關於女媧',
        designGuideilnes: '設計準則',
        nuwaRobotSDK: '女媧機器人SDK',
        motionList: '動作清單',
        forums: '論壇',
        bugReport: '回報錯誤',
        contactUs: '聯絡我們',
        nuwaHompage: '女媧首頁',
        jobOpportunities: '加入我們',
        buyNUWARobot: '購買機器人',
        termsAndAgreements: '協議條款',
        privacyPolicy: '隱私政策',

        // 新增
        homePageFileDocumentationSdkNullTop: '你似乎還沒登入喔！',
        homePageFileDocumentationSdkNullBot: '請先登入才能觀看下載！',
        homePageIntroducesHeaderStoreTop: '女媧商城讓您接觸到更多擁有女媧機器人的家庭',
        homePageIntroducesHeaderchildTop: '您能開發應用程式、故事、飾品等商品',
        homePageIntroducesHeaderchildBot: '並且，您的創意將被遍佈全國的孩子們使用',
        homePageIntroducesContentPlan: '女媧開發者計畫',
        homePageIntroducesContentPlanBot: '基于女媧擁有的豐富軟件技術，帮助開發者們快速發展應用程式及內容',
        homePageIntroducesContentPlatform: '平台開發者計畫',
        homePageIntroducesContentPlatformContOne: '通过适用于女媧機器人的商城向全國用戶推出您的 app',
        homePageIntroducesContentPlatformContTwo: '您还可以获取测试工具、開發文件以及 app 分析',
        homePageIntroducesContentPlatformContThree: '利用 Nuwa Developer Console 上的 App 分析来衡量您的用户参与情况和收入状况，且此分析无需額外',
        homePageIntroducesContentPlatformContFour: '技术性的編程配合',
        homePageIntroducesContentAdvanced: '進階開發合作夥伴',
        homePageIntroducesContentAdvancedContOne: '除了能自由在商城推出您的 app 之外，您還能再開發階段使用女媧',
        homePageIntroducesContentAdvancedContTwo: '提供的模擬器',
        homePageIntroducesContentAdvancedContThree: '透過模擬器，即使機器人不在身邊，您可以擁有機器人環境，繼續',
        homePageIntroducesContentAdvancedContFour: '創造、優化您的 app',
        homePageIntroducesContentCustomized: '客製化開發合作夥伴',
        homePageIntroducesContentCustomizedContOne: '與女媧協作開發，獲取更多資源。我們將進階提供 Unity SDK、更',
        homePageIntroducesContentCustomizedContTwo: '新服務，讓您的機器人的環境及軟件等能整體客製化更新',
        homePageIntroducesContentCustomizedContThree: '透過我們的更新服務，您將省下大量時間、精力及費用，即能創造',
        homePageIntroducesContentCustomizedContFour: '您獨一無二的機器人',
        homePageIntroducesBottomGuidelines: '準則與資源',
        homePageIntroducesBottomAbout: '閱讀設計與開發的規範，了解如何提交與行銷您的應用。',
        homePageIntroducesBottomWatch: '查看規範與資源',
        platformDeveloperProgram: '通過適用於女媧機器人的商城向全國用戶推出您的 app，您還可以獲取測試工具、開發文件以及 app 分析，利用 Nuwa Developer Console 上的 App 分析來衡量您的用戶參與情況和收入狀況，且此分析無需額外技術性的編程配合。',
        AdvancedPevelopmentPartners: '除了能自由在商城推出您的 app 之外，您還能再開發階段使用女媧提供的模擬器，透過模擬器，即使機器人不在身邊，您可以擁有機器人環境，繼續創造、優化您的 app。',
        customDevelopmentPartners: '與女媧協作開發，獲取更多資源。我們將進階提供 Unity SDK、更新服務，讓您的機器人的環境及軟件等能整體客製化更新，透過我們的更新服務，您將省下大量時間、精力及費用，即能創造您獨一無二的機器人。'
    }
}



// WEBPACK FOOTER //
// ./src/i18n/zhTw.js